import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useAlert } from "react-alert";
import { collection, doc, setDoc } from "firebase/firestore";

import { db } from "../../firebase";
import Input from "../Input";
import { ReactComponent as AngleLeft } from "../../images/AngleLeft.svg";
import { CategoriesArray } from "../../utility/data";
import "./AddProduct.scss";
import PosIconModal from "./PosIconModal";
import { Form } from "react-bootstrap";

const AddOptionCategory = ({ orgId, selectedCategory, setAddNew }) => {
  const { t } = useTranslation("editproduct");
  const userStore = useSelector((state) => state.userReducer);
  const [editModalOpen, setEditModalOpen] = useState(false);

  const [vatIn, setVatIn] = useState("");
  const [vatOut, setVatOut] = useState("");
  const [title, setTitle] = useState("");
  const [customIcon, setCustomIcon] = useState(CategoriesArray[0].name);
  const [multiSelect, setMultiSelect] = useState(false);
  const [autoAdd, setAutoAdd] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setMultiSelect(selectedCategory?.multiSelect === true);
    setAutoAdd(selectedCategory?.autoAdd === true);
    setTitle(selectedCategory?.title || "");
    setCustomIcon(selectedCategory?.customIcon || CategoriesArray[0].name);
    setVatIn(selectedCategory?.vatIn || "");
    setVatOut(selectedCategory?.vatOut || "");
  }, [selectedCategory]);

  const alert = useAlert();

  const saveCategory = async () => {
    if (saving) return;
    if (title.trim() === "") {
      alert.show(t("choose_name"), { type: "warning" });
      return;
    }

    const colRef = collection(db, "OptionCategories");
    const isEdit = Boolean(selectedCategory?.id);
    const docRef = isEdit ? doc(colRef, selectedCategory.id) : doc(colRef);
    const categoryData = {
      title,
      customIcon,
      vatIn,
      vatOut,
      uid: selectedCategory?.uid || userStore?.users.uid,
      orgId,
      multiSelect,
      autoAdd,
      id: isEdit ? selectedCategory.id : docRef.id,
    };
    setSaving(true);
    try {
      await setDoc(docRef, categoryData, { merge: true });
      setAddNew(false);
      alert.show(t(isEdit ? "category_updated" : "category_created"), { type: "success" });
    } catch (error) {
      console.error("Error writing document:", error);
      alert.show(t("something_went_wrong"), { type: "error" });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="add-product">
      <h4 className="add-product-title" onClick={() => setAddNew(false)}>
        <AngleLeft /> <div className="w-0 flex-grow-1">{t("return")}</div>
      </h4>
      <div className="item">
        <h5 className="subtitle">{t(selectedCategory?.id ? "edit_option_category" : "new_category")}</h5>
        <form onSubmit={(e) => e.preventDefault()}>
          <div className="mb-20">
            <Input
              label={t("title")}
              placeholder={t("category_name")}
              id="title"
              readOnly={Boolean(selectedCategory?.id)}
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              required="required"
            />
          </div>
          <div className="mb-20">
            <Input
              label={t("vat_in")}
              placeholder={t("enter_vat_in")}
              id="vat_in"
              value={vatIn}
              onChange={(e) => setVatIn(e.target.value)}
              required="required"
            />
          </div>
          <div className="mb-20">
            <Input
              label={t("vat_out")}
              placeholder={t("enter_vat_out")}
              id="vat_out"
              value={vatOut}
              onChange={(e) => setVatOut(e.target.value)}
              required="required"
            />
          </div>
          <div className="py-4 d-flex justify-content-between align-items-center border-y mb-4">
            <label htmlFor="option-multi-select" className="subtitle m-0">{t("allow_multi_select")}</label>
            <Form.Check
              id="option-multi-select"
              type="switch"
              checked={multiSelect}
              onChange={(e) => setMultiSelect(e.target.checked)}
            />
          </div>

          <div className="mb-4">
            <Form.Check
              id="option-auto-add"
              type="checkbox"
              label={t("auto_add_option")}
              checked={autoAdd}
              onChange={(e) => setAutoAdd(e.target.checked)}
              aria-describedby="option-auto-add-help"
            />
            <p id="option-auto-add-help" className="mt-2 mb-0">{t("auto_add_option_help")}</p>
          </div>

          <label className="form-label __form-label">{t("choose_icon")}</label>
          <div className="mb-4">
            <div
              className="productCard max-w-200 mx-auto cursor-pointer"
              onClick={() => setEditModalOpen(true)}
            >
              <div className="productImg">
                <img src={CategoriesArray.find((i) => i.name === customIcon).icon} alt="" />
              </div>
            </div>
          </div>
          <button
            type="submit"
            className="themeBtn btn-option m-0 w-100 pos-submit-btn"
            onClick={saveCategory}
            disabled={saving}
          >
            {t("save")}
          </button>
        </form>
        <PosIconModal
          modalOpen={editModalOpen}
          setModalOpen={setEditModalOpen}
          customIcon={customIcon}
          setCustomIcon={setCustomIcon}
          selectedCategory={"new"}
        />
      </div>
    </div>
  );
};

export default AddOptionCategory;
